module.exports = __webpack_public_path__ + "img/document.d52fc926.svg";